<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("payment_channel") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

                <div class="col-lg-6 col-5 text-right">
                    <base-button
                        size="md"
                        type="neutral"
                        @click="handleCreate()"
                        >{{ $t("new") }}</base-button
                    >

                    <!-- <base-button size="md" type="neutral" v-if="isCorporateAdmin || isDtacAdmin">{{
            $t("upload_file")
          }}</base-button> -->
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card
                    class="no-border-card"
                    body-classes="px-0 pb-1"
                    footer-classes="pb-2"
                >
                    <template slot="header">
                        <div class="col-lg-3">
                            <base-input
                                v-model="searchQuery"
                                prepend-icon="fas fa-search"
                                :placeholder="$t('search')"
                            >
                            </base-input>
                        </div>
                    </template>
                    <div>
                        <el-table
                            :data="queriedData"
                            row-key="id"
                            header-row-class-name="thead-light"
                        >
							<el-table-column :label="$t('name')">
								<div slot-scope="{  row }" >
									{{
										row.name
									}}

								</div>
                            </el-table-column>

							<el-table-column :label="$t('type')">
								<div slot-scope="{  row }" >
									<template v-if="(row.type==1)">โอนเงิน</template>
									<template v-if="(row.type==2)">เก็บเงินปลายทาง</template>
									<template v-if="(row.type==3)">บัตรเครดิต</template>
									<template v-if="(row.type==4)">เคลมสินค้า</template>
									<template v-if="(row.type==5)">Rabbit Line Pay</template>
									<template v-if="(row.type==6)">Platform</template>
									<template v-if="(row.type==7)">อื่น ๆ</template>
								</div>
                            </el-table-column>

							<el-table-column :label="$t('detail')" >
								<div slot-scope="{  row }" >
									<div v-if="(row.type==1)">
										{{ GetBankName(row.bank_id)}}
									{{ row.bank_account }}
									</div>
									</div>
                            </el-table-column>



                            <el-table-column
                                align="right"
                                :label="$t('actions')"
                            >
                                <div
                                    slot-scope="{ $index, row }"
                                    class="d-flex"
                                >
                                    <base-button
                                        @click.native="handleEdit($index, row)"
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-edit"></i>
                                    </base-button>
                                    <base-button
                                        @click.native="
                                            handleDelete($index, row)
                                        "
                                        class="remove btn-link"
                                        type="danger"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-trash"></i>
                                    </base-button>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div
                        slot="footer"
                        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                        v-if="tableData.length != 0"
                    >
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                                <span v-if="selectedRows.length">
                                    - &nbsp; &nbsp; {{ selectedRows.length }}
                                    {{ $t("row_select") }}
                                </span>
                            </p>
                        </div>
                        <base-pagination
                            class="pagination-no-border"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="total"
                        >
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>

        <modal :show.sync="showAddModal" modal-classes="modal-secondary">
			<validation-observer ref="formValidator" >

            <form class="new-event--form" @submit.prevent="saveEvent">
                <base-input :label="$t('name')" :name="$t('name')" v-model="params.name" rules="required"> </base-input>

				<base-input :label="$t('type')">
					<el-select v-model="params.type" :placeholder="$t('type')" filterable >
						<el-option
							v-for="option in paymentMethodTypeTable"
							:key="option.id"
							:label="option.name"
							:value="option.id"
						>
						</el-option>
					</el-select>
				</base-input>

				<base-input :label="$t('bank')" v-if="(params.type == 1)">
					<el-select
						v-model="params.bank_id"
						:placeholder="$t('bank')"
						filterable
					>
						<el-option
							v-for="option in bankTable"
							:key="option.id"
							:label="option.name"
							:value="option.id"
						>
						</el-option>
					</el-select>
				</base-input>

				<base-input :label="$t('bank_account')" v-model="params.bank_account" v-if="(params.type == 1)"> </base-input>
				<base-input :label="$t('bank_branch')" v-model="params.bank_branch" v-if="(params.type == 1)"> </base-input>


                <input type="hidden" class="new-event--start" />
                <input type="hidden" class="new-event--end" />
            </form>
			</validation-observer>

            <template slot="footer">
                <button
                    type="submit"
                    class="btn btn-md btn-primary"
                    @click="handleUpdate()"
                >
                    {{ $t("save") }}
                </button>
                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showAddModal = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

export default {
    mixins: [clientPaginationMixin],
    components: {
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            tableDataOrg: "PaymentMethod/getData",
            paymentMethodTypeTable: "PaymentMethod/getPaymentMethodTypeTable"
        }),
        tableData: function() {
            // if (this.$route.query.id != null) {
            //   return this.tableDataOrg.filter((m)=>{
            //     return m.EnterpriseID == "" + this.$route.query.id
            //   });
            // }

            return this.tableDataOrg;
        },
		
       
    },
    data() {
        return {
            propsToSearch: ["name", "bank_account", "bank_branch"],
            selectedRows: [],
            showAddModal: false,
            params: {
                id: 0,
                name: "",
                type: "",
                bank_id: "",
                bank_account: "",
                bank_branch: "",
                platform_id: 1
            },
			bankTable:[
				{id:2,name:"กรุงศรีอยุธยา"},
				{id:3,name:"กสิกรไทย"},
				{id:4,name:"ทหารไทยธนชาติ"},
				{id:5,name:"ซีไอเอ็มบี"},
				{id:6,name:"ไทยพาณิชย์"},
				{id:7,name:"ยูโอบี"},
				{id:8,name:"ทิสโก้"},
				{id:9,name:"กรุงเทพ"},

			]

        };
    },
    mounted() {
        this.listData();
    },
    methods: {
        ...mapActions({
            createData: "PaymentMethod/createData",
            updateData: "PaymentMethod/updateData",
            deleteData: "PaymentMethod/deleteData",
            listData: "PaymentMethod/listData"
        }),
		GetBankName (id){
			let banks = this.bankTable.filter((m)=>{
				return m.id == id
			});

			if (banks.length == 0) return "";
			return banks[0].name;
		},
        handleCreate(action) {
            this.showAddModal = true;
			this.params.id = 0,
			this.params.name =  "",
			this.params.type =  1,
			this.params.bank_id =  "",
			this.params.bank_account =  "",
			this.params.bank_branch =  "",
			this.params.platform_id =  1
        },
        handleEdit(index, row) {
            this.showAddModal = true;
			this.params.id =  row.id,
			this.params.name =  row.name,
			this.params.type =  row.type,
			this.params.bank_id =  row.bank_id,
			this.params.bank_account =  row.bank_account,
			this.params.bank_branch =  row.bank_branch,
			this.params.platform_id =  row.platfrom_id
        },
        async handleUpdate() {
            // Create
			let valid = await this.$refs.formValidator.validate()
			if (!valid) return

            this.showAddModal = false;

            if (this.params.id == 0) {
                this.createData(this.params)
                    .then(resp => {
                        this.listData();
                        swal.fire({
                            title: this.$t("create_success"),
                            text: ``,
                            icon: "success",
                            confirmButtonClass: "btn btn-success btn-fill",
                            buttonsStyling: false
                        });
                    })
                    .catch(err => {
                        swal.fire({
                            title: this.$t(err.response.data.Msg),
                            text: this.getErrorText(err.response.data),
                            icon: "error",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
                    });
            } else {
                // Update
                this.updateData({id:this.params.id , payload:this.params})
                    .then(resp => {
                        this.listData();
                        swal.fire({
                            title: this.$t("edit_success"),
                            text: ``,
                            icon: "success",
                            confirmButtonClass: "btn btn-success btn-fill",
                            buttonsStyling: false
                        });
                    })
                    .catch(err => {
                        swal.fire({
                            title: this.$t(err.response.data.Msg),
                            text: this.getErrorText(err.response.data),
                            icon: "error",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
                    });
            }
        },
        handleDelete(index, row) {
            swal.fire({
                title: this.$t("delete_confirm"),
                text: this.$t("delete_confirm_question") + row.name,
                icon: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-danger btn-fill",
                confirmButtonText: this.$t("confirm"),
                cancelButtonText: this.$t("cancel"),
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    this.deleteData(row.id)
                        .then(resp => {
                            this.listData();
                            swal.fire({
                                title: this.$t("delete_success"),
                                text: ``,
                                icon: "success",
                                confirmButtonClass: "btn btn-success btn-fill",
                                buttonsStyling: false
                            });
                        })
                        .catch(err => {
                            swal.fire({
                                title: this.$t(err.response.data.Msg),
                                text: this.getErrorText(err.response.data),
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                        });
                }
            });
        },
    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
